<template>
    <v-row>
        <v-col>
            <v-card>
                <meetings-card-title title="Alle møder med valgte filtre" :count="meetings.length" />
                <div>
                    <v-subheader class="pa-0">
                        <v-col v-for="(header, index) in $store.state.meetings.meetingHeaders" :key="index" :cols="header.cols" class="text-center">
                            {{ header.header }}
                        </v-col>
                    </v-subheader>
                    <meeting v-for="meeting in paginatedMeetings" :key="meeting.id" :initialMeeting="meeting" @meetingDeleted="$emit('meetingDeleted')" />
                </div>
                <div v-if="meetings.length > itemsPerPage">
                    <v-pagination
                        v-model="page"
                        @input="paginateMeetings"
                        :length="Math.ceil(meetings.length / itemsPerPage)"
                        :total-visible="10"
                    />
                </div>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import meeting from '@/views/Booking/Components/meeting'
import meetingsCardTitle from '@/views/Booking/Components/meetingsCardTitle'

export default {
    components: {
        meeting,
        meetingsCardTitle
    },
    props: [
        'meetings'
    ],
    data () {
        return {
            paginatedMeetings: null,
            page: 1,
            itemsPerPage: 7,

        }
    },
    methods: {
        paginateMeetings() {
            this.paginatedMeetings = [...this.meetings].splice(this.itemsPerPage * (this.page - 1), this.itemsPerPage)
        }
    },
    created () {
        this.$store.state.meetings.updatedMeetings = {}
        this.paginateMeetings()
    }
}
</script>